module.exports = __webpack_public_path__ + "static/img/app-slide-show3.6391f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-tb-wgm/images/app-slide-show3.png
// module id = n9xy
// module chunks = 44